
<template>
  <vx-card>
    <div slot="no-body" class="px-6 pt-6 tabs-container">
      <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
        <vs-tab label="Account" icon-pack="feather" icon="icon-user">
          <div class="tab-text">
            <div id="user-edit-tab-info">
              <!-- Avatar Row -->
              <div class="vx-row">
                <div class="w-full vx-col">
                  <div class="flex flex-col items-start sm:flex-row">
                    <div class="mr-2" v-if="changeAvatar === true">
                      <Upload
                        width="125px"
                        height="125px"
                        @on-success="success"
                        @on-error="error"
                        @on-delete="deleteImage"
                        limit="1"
                      ></Upload>
                    </div>
                    <div class="mt-8 ml-8 mr-8 rounded" v-else>
                      <img
                        :src="
                          user.photoURL === null || user.photoURL === undefined
                            ? require('@/assets/images/portrait/small/avatar.svg')
                            : getUserAvatar(user.photoURL)
                        "
                        style="width: 125px; height: 125px"
                      />
                    </div>
                    <div class="mt-10">
                      <p class="mt-4 mb-2 text-lg font-medium sm:mt-0">
                        {{ user.fullName }}
                      </p>
                      <vs-button
                        type="border"
                        class="mt-5 mr-4"
                        @click="changeAvatar = !changeAvatar"
                        >Change Avatar</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- Content -->
              <ValidationObserver v-slot="{ invalid }">
                <div class="mt-6 vx-row">
                  <div class="w-full vx-col md:w-1/2">
                    <!-- Full Name -->
                    <ValidationProvider
                      immediate
                      name="full name"
                      rules="required|alpha_spaces|min:3|max:100"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        name="fullName"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label="Full Name"
                        v-model="user.fullName"
                        class="w-full mt-4"
                        :success="errors.length === 0"
                        success-text="Full Name is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="w-full vx-col md:w-1/2">
                    <!-- E-mail -->
                    <ValidationProvider
                      immediate
                      name="email address"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-mail"
                        icon-pack="feather"
                        label="Email address"
                        v-model="user.email"
                        class="w-full mt-4"
                        :success="errors.length === 0"
                        success-text="Email address is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="w-full vx-col md:w-1/2">
                    <!-- Current Password -->
                    <ValidationProvider
                      immediate
                      name="current password"
                      :rules="
                        user.password === ''
                          ? 'required|min:6|max:30'
                          : '|min:6|max:30'
                      "
                      v-slot="{ errors }"
                    >
                      <vs-input
                        type="password"
                        name="current_password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="Current Password"
                        v-model="user.password"
                        class="w-full special-form"
                        :success="errors.length === 0"
                        success-text="Password is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="w-full vx-col md:w-1/2">
                    <!-- New Password -->
                    <ValidationProvider
                      name="new password"
                      rules="min:6|max:30"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        type="password"
                        name="new_password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="New Password"
                        v-model="user.newPassword"
                        class="w-full special-form"
                        :success="errors.length === 0"
                        success-text="Password is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                </div>

                <!-- Save & Reset Button -->
                <div class="vx-row">
                  <div class="w-full vx-col">
                    <div class="flex flex-wrap items-center justify-end mt-8">
                      <vs-button
                        class="mt-2 ml-auto"
                        @click="updateUser"
                        :disabled="invalid"
                        >Save Changes</vs-button
                      >
                      <vs-button
                        class="mt-2 ml-4"
                        type="border"
                        color="warning"
                        @click="reset_data"
                        >Reset</vs-button
                      >
                    </div>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="API Access" icon-pack="feather" icon="icon-link-2">
          <div class="tab-text">
            <template v-if="user.apiAccess && user.apiAccess.active">
              <h3 class="mb-4">API Details</h3>
              <div class="flex flex-col">
                <label for="api-key" class="mb-1 text-xs">Your API Key</label>
                <input
                  class="p-2 bg-gray-200 border border-gray-500 rounded-lg"
                  name="api-key"
                  :type="showApiKey ? 'text' : 'password'"
                  :value="user.apiAccess.apiKey"
                  readonly
                  style="width: 55ch"
                />
                <div class="flex items-center mt-2 space-x-2">
                  <input id="show-api-key" type="checkbox" name="show-api-key" v-model="showApiKey" />
                  <label for="show-api-key" class="text-xs">Show API key</label>
                </div>
              </div>

              <h5 class="mt-6 mb-2">Scopes</h5>
              <div class="flex items-center mt-2 space-x-2">
                  <input id="list-simulations" type="checkbox" name="list-simulations" v-model="user.apiAccess.apiSettings.listSimulations" />
                  <label for="list-simulations" class="text-xs">List Simulations</label>
              </div>
              <div class="flex items-center mt-2 space-x-2">
                  <input id="create-simulations" type="checkbox" name="create-simulations" v-model="user.apiAccess.apiSettings.createSimulations" />
                  <label for="create-simulations" class="text-xs">Create Simulations</label>
              </div>
              <div class="flex items-center mt-2 space-x-2">
                  <input id="delete-simulations" type="checkbox" name="delete-simulations" v-model="user.apiAccess.apiSettings.deleteSimulations" />
                  <label for="delete-simulations" class="text-xs">Delete Simulations</label>
              </div>
               <vs-button
                  class="mt-8 ml-auto"
                  @click="updateAPIScopes"
                  :disabled="invalid"
                  >Update API Scopes</vs-button
                >
                <vs-button
                  class="mt-8 ml-4"
                  type="border"
                  color="danger"
                  @click="revokeAPIAccess"
                  >Revoke API Access</vs-button
                >
            </template>
            <template v-else>
              Seems like you haven't enable your API access yet,
              <a class="cursor-pointer" @click="enableAPI">enable now.</a>
            </template>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>

<script>
import Upload from "../upload/Upload";
export default {
  components: {
    Upload,
  },
  data() {
    return {
      activeTab: 0,
      changeAvatar: false,
      image_id: null,
      user: {
        fullName: "",
        email: "",
        photoURL: "",
        password: "",
        newPassword: "",
        apiAccess: {},
      },
      showApiKey: false
    };
  },
  methods: {
    revokeAPIAccess(){
      this.$swal({
        title: "Do you really want to revoke API access?",
        input: "password",
        inputLabel: "Password",
        inputPlaceholder: "Enter your password",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((password) => {
        if (password && password.value ) {
          this.$vs.loading();
          const data = {
            password: password.value
          };

          this.$http
            .put("/user/revoke-api-access", data)
            .then((res) => {
              this.$vs.loading.close();
              this.reset_data();
              if (res.data.status && res.data.status === true) {
                this.$swal({
                  position: "bottom-start",
                  icon: "success",
                  toast: true,
                  title: "API access successfully revoked",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
            })
            .catch((err) => {
              this.$vs.loading.close();
              this.reset_data();
              this.$swal({
                position: "bottom-start",
                icon: "error",
                toast: true,
                title: err.response.data.message,
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
    updateAPIScopes(){
      this.$swal({
        title: "Do you really want to update API scoped?",
        input: "password",
        inputLabel: "Password",
        inputPlaceholder: "Enter your password",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((password) => {
        if (password && password.value) {
          this.$vs.loading();
          const data = {
            password: password.value,
            listSimulations: this.user.apiAccess.apiSettings.listSimulations,
            deleteSimulations: this.user.apiAccess.apiSettings.deleteSimulations,
            createSimulations: this.user.apiAccess.apiSettings.createSimulations,
            whiteListIPs: [],
          };

          this.$http
            .put("/user/api-access", data)
            .then((res) => {
              this.$vs.loading.close();
              this.reset_data();
              if (res.data.status && res.data.status === true) {
                this.$swal({
                  position: "bottom-start",
                  icon: "success",
                  toast: true,
                  title: "API scoped successfully updated",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
            })
            .catch((err) => {
              this.$vs.loading.close();
              this.reset_data();
              this.$swal({
                position: "bottom-start",
                icon: "error",
                toast: true,
                title: err.response.data.message,
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
    enableAPI() {
      this.$swal({
        title: "Do you really want to enable API access?",
        input: "password",
        inputLabel: "Password",
        inputPlaceholder: "Enter your password",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((password) => {
        if (password && password.value) {
          this.$vs.loading();
          const data = {
            password: password.value,
            listSimulations: true,
            deleteSimulations: false,
            createSimulations: false,
            whiteListIPs: [],
          };

          this.$http
            .put("/user/api-access", data)
            .then((res) => {
              this.$vs.loading.close();
              this.reset_data();
              if (res.data.status && res.data.status === true) {
                this.$swal({
                  position: "bottom-start",
                  icon: "success",
                  toast: true,
                  title: "API access successfully enabled",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
            })
            .catch((err) => {
              this.$vs.loading.close();
              this.reset_data();
              this.$swal({
                position: "bottom-start",
                icon: "error",
                toast: true,
                title: err.response.data.message,
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
    reset_data() {
      this.image_id = null;
      this.changeAvatar = false;
      this.loadUser();
    },
    success(data) {
      this.image_id = data.message;
    },
    error(err) {
      this.$swal({
        position: "bottom-start",
        icon: "error",
        toast: true,
        title: err.data.message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    },
    deleteImage(data) {
      if (this.image_id !== null) {
        this.$http
          .delete(`/images/${this.image_id}`)
          .then((res) => {
            this.$swal({
              position: "bottom-start",
              icon: "success",
              toast: true,
              title: "Image successfully deleted.",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((err) => {
            this.$swal({
              position: "bottom-start",
              icon: "error",
              toast: true,
              title: err.response.message,
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
        this.image_id = null;
      }
    },
    getUserAvatar(photoURL) {
      return `${process.env.VUE_APP_BASE_URL}/images/${photoURL}`;
    },
    updateUser() {
      this.$swal({
        title: "Warning",
        text: "Do you really want to update your user profile?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$vs.loading();
          const data = {
            fullName: this.user.fullName,
            email: this.user.email,
            photoURL: this.user.photoURL,
            password: this.user.password,
          };
          if (this.user.newPassword.length > 0) {
            data.newPassword = this.user.newPassword;
          }
          if (this.image_id !== null) {
            data.photoURL = this.image_id;
          }
          this.$http
            .put("/user/profile", data)
            .then((res) => {
              this.$vs.loading.close();
              this.reset_data();
              if (res.data.status && res.data.status === true) {
                this.$swal({
                  position: "bottom-start",
                  icon: "success",
                  toast: true,
                  title: "User successfully updated",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
            })
            .catch((err) => {
              this.$vs.loading.close();
              this.reset_data();
              this.$swal({
                position: "bottom-start",
                icon: "error",
                toast: true,
                title: err.response.data.message,
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
    loadUser() {
      this.$http.get("/user/profile").then((res) => {
        if (res.data.status && res.data.status === true) {
          const { fullName, email, photoURL, apiAccess } = res.data.user;
          this.user.fullName = fullName;
          this.user.email = email;
          this.user.photoURL = photoURL;
          this.user.apiAccess = apiAccess;
        }
      });
    },
  },
  created() {
    this.loadUser();
  },
};
</script>


<style scoped>
.con-input-upload {
  height: 100px;
  width: 100px !important;
}
</style>